import { createContext, useContext, useEffect, useState } from "react";
import { studioApi, STUDIO_TOKEN_KEY } from "@/lib/studioApi";

const StudioAuthContext = createContext(null);

export function StudioAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null = checking, false = anon, obj = signed in
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // If arriving from Google OAuth callback, let StudioDashboard exchange the session first.
    if (typeof window !== "undefined" && (window.location.hash || "").includes("session_id=")) {
      setReady(true);
      return;
    }
    const token = localStorage.getItem(STUDIO_TOKEN_KEY);
    if (!token) {
      setCustomer(false);
      setReady(true);
      return;
    }
    studioApi
      .get("/studio/auth/me")
      .then((r) => setCustomer(r.data))
      .catch(() => {
        localStorage.removeItem(STUDIO_TOKEN_KEY);
        setCustomer(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await studioApi.post("/studio/auth/login", { email, password });
    localStorage.setItem(STUDIO_TOKEN_KEY, data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const register = async (payload) => {
    const { data } = await studioApi.post("/studio/auth/register", payload);
    localStorage.setItem(STUDIO_TOKEN_KEY, data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const logout = () => {
    localStorage.removeItem(STUDIO_TOKEN_KEY);
    setCustomer(false);
  };

  return (
    <StudioAuthContext.Provider value={{ customer, ready, login, register, logout }}>
      {children}
    </StudioAuthContext.Provider>
  );
}

export const useStudioAuth = () => useContext(StudioAuthContext);
